import { Box, Stack, Typography, type TypographyProps } from '@mui/material';
import React, { type ElementType } from 'react';

export const TypographyIcon = ({
  icon: Icon,
  children,
  size = 'medium',
  ...rest
}: {
  icon: ElementType;
  size?: 'small' | 'medium' | 'large';
} & TypographyProps) => {
  return (
    <Stack direction="row" alignItems="center">
      <Box mr={1} display="flex" alignItems="center" color={rest.color}>
        <Icon fontSize={size} />
      </Box>
      <Typography {...rest}>{children}</Typography>
    </Stack>
  );
};
